import React from 'react';
import { Helmet } from "react-helmet";
import Layout from "../../Layout/layout";
import "../../styles/realTime/realTime.scss";

function noRecords(props) {
    return (
        <React.Fragment>
            <Layout customGroups={true}>
                <Helmet>
                    <title>RealTime </title>
                </Helmet>
                <div className="contentBody">
                    <div className="contentWrapper">
                        <div>
                            <h1 className="real-heading">Real Time <span className="real-span">v1.0.3</span></h1>
                            <div>
                                <h2>No Assets assigned</h2>
                                <h3>Currently there are no Assets assigned to this Group</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default noRecords;
